import clsx from 'clsx';
import CircularProgress from '@material-ui/core/CircularProgress';
import React from 'react';
import PropTypes from 'prop-types';

export const LoadingCircle = ({ isLoading, styles }) => (
  <CircularProgress
    className={clsx(styles.loading, {
      [styles.hide]: !isLoading,
    })}
  />
);

LoadingCircle.propTypes = {
  styles: PropTypes.shape({
    hide: PropTypes.string,
    loading: PropTypes.string,
  }),
  isLoading: PropTypes.bool.isRequired,
};

LoadingCircle.defaultProps = {
  styles: {
    loading: 'makeStyles-loading-160',
    hide: 'makeStyles-hide-157',
  },
};

export default LoadingCircle;
